import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Projects from './view/projects';

const ProjectsRoutes = () => (
    <ErrorBoundaryRoutes>
        <Route index element={<Projects />} />
    </ErrorBoundaryRoutes>
);

export default ProjectsRoutes;
